import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function ProgressReportSkeleton({ isDarkMode }) {
    const cardCls = `rounded-2xl border shadow-sm ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200"}`;
    const bannerCls = "rounded-2xl px-4 py-4 md:px-6 md:py-6 bg-primary-900/90";
    const tileCls = "bg-primary-800/40 rounded-xl px-4 py-5";
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";
    const bannerBaseColor = "rgba(255,255,255,0.16)";
    const bannerHighlightColor = "rgba(255,255,255,0.3)";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className={`min-h-screen ${isDarkMode ? "bg-surface" : "bg-surface"}`}>
                <div className="max-w-6xl mx-auto px-4 py-6 md:py-8">
                    {/* Header */}
                    <header className="mb-6 md:mb-10">
                        <Skeleton width={220} height={30} className="mb-2" />
                        <Skeleton width={360} height={18} />
                    </header>

                    {/* Stat cards grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-6 md:mb-8">
                        {Array.from({ length: 6 }).map((_, i) => (
                            <div key={i} className={`${cardCls} p-4 md:p-6`}>
                                <div className="flex items-center justify-between mb-2 md:mb-4">
                                    <Skeleton circle width={40} height={40} />
                                    <Skeleton width={60} height={20} borderRadius={999} />
                                </div>
                                <Skeleton width={110} height={16} className="mb-2" />
                                <Skeleton width={80} height={32} />
                                <Skeleton width={150} height={14} className="mt-2" />
                            </div>
                        ))}
                    </div>

                    {/* Weekly Progress by Focus Area */}
                    <section className="mb-8">
                        <div className={`${cardCls} p-4 md:p-6`}>
                            <Skeleton width={240} height={22} className="mb-4" />
                            <div className="space-y-4">
                                {Array.from({ length: 4 }).map((_, i) => (
                                    <div key={i}>
                                        <div className="flex items-center justify-between mb-1">
                                            <Skeleton width={120} height={16} />
                                            <Skeleton width={140} height={14} />
                                        </div>
                                        <Skeleton height={10} borderRadius={999} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>

                    {/* Overall Performance banner */}
                    <SkeletonTheme baseColor={bannerBaseColor} highlightColor={bannerHighlightColor}>
                        <section className={`${bannerCls} mb-6`}>
                            <Skeleton width={200} height={22} className="mb-4" />
                            <div className="grid grid-cols-2 gap-3 md:gap-4 lg:grid-cols-4">
                                {Array.from({ length: 4 }).map((_, i) => (
                                    <div key={i} className={tileCls}>
                                        <Skeleton width={100} height={12} />
                                        <Skeleton width={60} height={26} className="mt-2" />
                                    </div>
                                ))}
                            </div>
                        </section>

                        {/* Quarterly Task Plan banner */}
                        <section className={bannerCls}>
                            <div className="flex items-center justify-between flex-wrap gap-3 mb-2">
                                <Skeleton width={190} height={24} />
                                <Skeleton width={120} height={32} borderRadius={8} />
                            </div>
                            <Skeleton width={220} height={16} className="mb-4" />
                            <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                                {Array.from({ length: 2 }).map((_, c) => (
                                    <div key={c} className={tileCls}>
                                        <div className="flex items-center justify-between mb-3">
                                            <Skeleton width={90} height={16} />
                                            <Skeleton circle width={32} height={32} />
                                        </div>
                                        {Array.from({ length: 3 }).map((_, r) => (
                                            <Skeleton key={r} height={36} borderRadius={8} className="mb-2" />
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </section>
                    </SkeletonTheme>
                </div>
            </div>
        </SkeletonTheme>
    );
}
